import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
// import Home from '../pages/Home.vue';
//import ScreenDesign1 from '../pages/ScreenDesign1.vue';
import ScreenDesign2 from '../pages/ScreenDesign2/ScreenDesign2.vue';
//import ScreenDesign3 from '../pages/ScreenDesign3/ScreenDesign3.vue';
//import { component } from 'vue/types/umd';
const routes = [
  { path: '/home', component: ScreenDesign2, name:'ScreenDesign2' },
  { path: '/', redirect: '/home' },   /*默认跳转路由*/
]

const router = new VueRouter({
  mode: 'hash', 
  routes 
})

export default router;